/**
 * @module experience/shared-experience
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
// interfaces
import {
  RemorseExchangeRequestPayload,
} from '@support/api/proxies/responses/api-cart-response.interface';
// constants
import { DEVICE_ASSESSSMENT_CONSTANT } from '@experience/device-assessment/device-assessment.constants';

export class RemorseExchangeCartPayloadModel {
  /**
   * Stores the value of request payload for remorse exchange
   */
  public RequestPayloadRemorseExchange: RemorseExchangeRequestPayload;

  constructor(
    private sku: string,
    private offerId: string,
    private returningItemId?: string
  ) {
    const payload: RemorseExchangeRequestPayload = {
      offerId: offerId,
      sku: sku,
      reason: DEVICE_ASSESSSMENT_CONSTANT.REMORSE,
      transactionTypes: DEVICE_ASSESSSMENT_CONSTANT.EXCHANGE,
      quantity: 1,
    };

    if (this.returningItemId) {
      payload.itemRelation = {
        cartItemIdFrom: this.returningItemId,
        relationshipType: DEVICE_ASSESSSMENT_CONSTANT.EXCHANGE,
      };
    }

    this.RequestPayloadRemorseExchange = payload;
  }
}
